"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPreviousRange = void 0;

var _getRangeId = require("./get-range-id");

var _getRanges = require("./get-ranges");

/**
 * @description
 * returns the previous to the selected range in the ipv4 control
 * @Function
 *
 * @example
 *   for and IP Address 192.167.182,165,
 *   if 182 is selected, getPreviousRange will return [4,7]
 *
 * @name skybase-components.sb-ipv4-input.utils#getPreviousRange
 * @param  {String} [ip='']
 * @param  {skybase-components.sb-ipv4-input.utils#Range} currentRange
 * @param  {Boolean} forceNext
 * @return {skybase-components.sb-ipv4-input.utils#Range}
 */
var getPreviousRange = function getPreviousRange() {
  var ip = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var currentRange = arguments.length > 1 ? arguments[1] : undefined;
  var forcePrevious = arguments.length > 2 ? arguments[2] : undefined;
  var chunkRanges = (0, _getRanges.getRanges)(ip);
  var chunkId = (0, _getRangeId.getRangeId)(chunkRanges, currentRange[1]);
  var currentChunk = chunkRanges[chunkId] || 0;
  var shouldSkipToPreviousChunk = currentChunk[0] !== 0 || forcePrevious;

  if (chunkId !== 0) {
    return shouldSkipToPreviousChunk ? chunkRanges[chunkId - 1] : currentRange;
  }

  var firstPos = chunkRanges[0][0];
  return [firstPos, firstPos];
};

exports.getPreviousRange = getPreviousRange;
//# sourceMappingURL=get-previous-range.js.map